import { AppAction } from "../../root/AppAction";
import { UserFilter } from "./models/UserFilter";
import UserFilterEvents from "./UserFilterEvents";

export interface UserFilterStore {
  UserFilters: UserFilter;
}

const initialStore: UserFilterStore = {
  UserFilters: { id: -1, skill: [], tag: [] },
};

export default function userFilter(
  state: UserFilterStore = initialStore,
  action: AppAction
) {
  if (action.type === UserFilterEvents.resetUserfilter) {
    return {
      UserFilters: action.UserFilters,
    };
  } else {
    return state;
  }
}
